__turbopack_context__.v({
  "component": "style-module-scss-module__7hiVwG__component",
  "hidden": "style-module-scss-module__7hiVwG__hidden",
  "indented": "style-module-scss-module__7hiVwG__indented",
  "no-padding": "style-module-scss-module__7hiVwG__no-padding",
  "shown": "style-module-scss-module__7hiVwG__shown",
});
